import { Button, MuiThemeProvider, TextField, Tooltip, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { PureComponent } from 'react';
import * as React from 'react';
import { productNewService } from 'services/productNewService';

interface IState {
  scriptFirstStep: string;
  scriptSecondStep: string;
  openTooltipFirstStep: boolean;
  openTooltipSecondStep: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  instructions: {
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    position: 'relative',
    height: '85vh',
    overflow: 'auto'
  },
  instructionsTitle: {
    fontSize: 24,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      width: 20,
      fill: theme.variables.colors['link'],
      marginRight: 8
    }
  },
  step: {
    paddingTop: 16
  },
  copyButton: {
    width: 55,
    backgroundColor: theme.variables.colors['title'],
    color: '#FFF',
    fontSize: 14,
    textTransform: 'none',
    position: 'absolute',
    zIndex: 1,
    right: 16,
    marginTop: 16,
    '&:hover': {
      backgroundColor: theme.variables.colors['inputColorHover']
    }
  },
  disableInput: {
    pointerEvents: 'none'
  }
}))
export default class WidgetInstructions extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      scriptFirstStep: '',
      scriptSecondStep: '',
      openTooltipFirstStep: false,
      openTooltipSecondStep: false
    };
  }

  copyScriptFirstStep = () => {
    const copyText: HTMLInputElement = document.getElementById('firstStep') as HTMLInputElement;
    copyText.select();

    document.execCommand('copy');
    this.setState({ openTooltipFirstStep: true });
    setTimeout(this.closeTooltipFirstStep, 3000);
  };

  copyScriptSecondStep = () => {
    const copyText: HTMLInputElement = document.getElementById('secondStep') as HTMLInputElement;
    copyText.select();

    document.execCommand('copy');
    this.setState({ openTooltipSecondStep: true });
    setTimeout(this.closeTooltipSecondStep, 3000);
  };

  closeTooltipFirstStep = () => {
    this.setState({ openTooltipFirstStep: false });
  };

  closeTooltipSecondStep = () => {
    this.setState({ openTooltipSecondStep: false });
  };

  componentDidMount() {
    productNewService.getSelectedProduct().subscribe(product => {
      const scriptFirstStep = `<script type="text/javascript">(function () {
          EdzLs = [];
          Eduzz = function (t, a, c) {
              EdzLs.push({type: t, args: a, caller: c});
              if (window.edz) window.edz();
          };
          var s = document.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.defer = true;
          s.src = "https://sun.eduzz.com/widget/main.js";
          window.edzScript = s;
          var x = document.getElementsByTagName("script")[0];
          if (!x) x = document.getElementsByTagName("body")[0].firstChild();
          x.parentNode.insertBefore(s, x);
        })();
      </script>`;
      const scriptSecondStep = `<button type="button"
        onclick="Eduzz('Widget', { id: ${product?.id} }, this);" >Comprar agora!</button>`;
      this.setState({ scriptFirstStep, scriptSecondStep });
    });
  }

  render() {
    const { classes } = this.props;
    const { scriptFirstStep, scriptSecondStep, openTooltipFirstStep, openTooltipSecondStep } = this.state;

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div className={classes.instructions}>
          <div className={classes.instructionsTitle}>
            <SvgIcon name="alert" />
            <Typography variant="h6" className={classes.instructionsTitle}>
              Instruções de uso
            </Typography>
          </div>
          <div className={classes.step}>
            <Typography variant="h6" gutterBottom>
              Passo 1
            </Typography>
            <Typography variant="body1">Inclua esse script diretamente no html da sua página de vendas:</Typography>
            <Tooltip
              open={openTooltipFirstStep}
              onClose={this.closeTooltipFirstStep}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Script copiado com sucesso"
              leaveDelay={10}
            >
              <Button variant="raised" className={classes.copyButton} onClick={this.copyScriptFirstStep}>
                Copiar
              </Button>
            </Tooltip>
            <TextField
              id="firstStep"
              fullWidth
              multiline
              rows="8"
              rowsMax="8"
              value={scriptFirstStep}
              margin="normal"
              InputProps={{
                disableUnderline: true
              }}
              inputProps={{
                className: classes.disableInput
              }}
            />
          </div>
          <div className={classes.step}>
            <Typography variant="h6" gutterBottom>
              Passo 2
            </Typography>
            <Typography variant="body1">Esse é o código do botão, coloque-o na sua página de vendas:</Typography>
            <Tooltip
              open={openTooltipSecondStep}
              onClose={this.closeTooltipSecondStep}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Script copiado com sucesso"
              leaveDelay={10}
            >
              <Button variant="raised" className={classes.copyButton} onClick={this.copyScriptSecondStep}>
                Copiar
              </Button>
            </Tooltip>
            <TextField
              id="secondStep"
              fullWidth
              multiline
              rows="5"
              rowsMax="5"
              value={scriptSecondStep}
              margin="normal"
              InputProps={{
                disableUnderline: true
              }}
              inputProps={{
                className: classes.disableInput
              }}
            />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
